

export enum SortableListKey {
  MEASURES = 'measures',
  CUTS = 'cuts',
  ELEVATIONS = 'elevations',
  MARKERS = 'markers',
  VOLUMES = 'volumes',
  DETECTIONS = 'detections',
}

export const SORT_FIELD = {
  NAME: 'name',
  CONFIDENCE: 'confidence',
  EVOLUTION: 'evolution',
  VALUE: 'value',
  VOLUME: 'volume',
  TYPE: 'type',
  EMERGENCY: 'emergency'
} as const;

export type SortField = typeof SORT_FIELD[keyof typeof SORT_FIELD];


export enum SortDirection {
  NONE = 'none',
  ASC = 'asc',
  DESC = 'desc',
}


export interface SortConfig {
  field: SortField | null;
  direction: SortDirection;
}
